/** "1 record", "1,204 records". `many` defaults to `one` plus an "s". */
export function plural(count: number, one: string, many = `${one}s`): string {
  return `${count.toLocaleString()} ${count === 1 ? one : many}`;
}
